import useTranslation from 'next-translate/useTranslation'
import React, { useEffect, useState } from 'react'
import Trans from 'next-translate/Trans'
import useMap from 'tennders-transactions/hooks/useMap'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import useOffer from 'tennders-market/offer/hooks/useOffer'
import { GInput } from 'tennders-common/form/components'
import { useToast } from 'tennders-common/hooks/useToast'
import GHref from 'tennders-market/common/components/element/GHref'
import GCurrency from 'tennders-market/common/components/element/GCurrency'
import DistanceInKm from 'tennders-common/components/DistanceInKM'
import { calculateRouteDistance } from 'tennders-stracture/libs/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import OfferSentMessage from '../../../market/offer/views/first-offer/OfferSentMessage'

const TruckOffer = ({ truckTransaction, loadTransaction, fillMap, onRefresh }) => {
  const { t } = useTranslation()
  const { toastSuccess } = useToast()
  const { refreshTransaction } = useTransactions()
  const [form, setform] = useState({})
  const [step, setstep] = useState(0)
  const [submitting, setsubmitting] = useState(false)
  const {
    makeOffer,
    errors,
    setShowRouteOf,
    setOfferingToTruck,
    savingRoute
  } = useOffer()

  const {
    mapForm, setEditMode,
    setMapForm,
    setSelectedDistance,
    mapprops, getMapProps,
    selectedDistance,
    setRouteSelectable,
    selectedRoute
  } = useMap()
  const onChange = (k, v) => {
    setform({ ...form, [k]: v })
  }

  const sendBid = async () => {
    setsubmitting(true)

    setTimeout(async () => {
      const params = {
        ...form,
        ...mapForm,
        load: loadTransaction?.matchedLoad?.id,
        route: selectedRoute?.route,
        routeDetails: selectedRoute?.routeDetails,
        saveCallback: selectedRoute?.save
      }

      if (selectedRoute?.distance) {
        params.distance = selectedRoute?.distance
      }

      const response = await makeOffer(truckTransaction, params)

      if (response?.id) {
        toastSuccess('Offer is sent')
        setstep(3)
        setOfferingToTruck(false)
        onRefresh()
        refreshTransaction()
      }

      setsubmitting(false)
    }, 50)
  }
  useEffect(() => {
    if (mapprops?.content) {
      setShowRouteOf(loadTransaction)
    }
  }, [mapprops])

  const initMap = async () => {
    await getMapProps(loadTransaction?.id)
  }

  useEffect(() => {
    if (fillMap) {
      setSelectedDistance(0)
      initMap()
    }

    return () => {
      if (fillMap) {
        setSelectedDistance(0)
        setMapForm({})
      }
    }
  }, [loadTransaction])

  useEffect(() => {
    if (step > 1) {
      setRouteSelectable(false)
    }
  }, [step])

  useEffect(() => {
    setstep(0)
    setEditMode(true)
  }, [truckTransaction])

  useEffect(() => {
    let active = true
    if (mapForm?.pickupRoute && Object.keys(mapForm?.pickupRoute).length > 0) {
      calculateRouteDistance([truckTransaction?.pickupRoute, mapForm?.pickupRoute], (result) => {
        if (active) {
          if (result?.distance) {
            setform({ ...form, emptyKm: result?.distance })
            setMapForm({ ...mapForm, emptyKm: result?.distance })
          }
        }
      })
    }

    return () => {
      active = false
    }
  }, [mapForm?.pickupRoute])

  const isRouteOffered = mapForm?.pickupRoute && mapForm?.deliveryRoute

  return (

    <tr>
      <td colSpan="2" className="tennders-offer-panel-table w-100 p-0 pos-rel">
        <div className="w-90 bg-color-white pos-rel p-8">
          <div className="d-flex align-center justify-space pos-rel border-b">
            <div className="w-50">
              <div className="p-10">
                <div className="d-flex align-center">
                  <div className="step-no mr-10">1</div>
                  <div className="flex-1">{t('transaction:fillInfoPrompt')}</div>
                </div>
              </div>
            </div>
            <div className="w-50 text-right">
              <div className="p-10">
                <GHref
                  disabled={!isRouteOffered}
                  onClick={() => setstep(1)}
                  className="btn standard-btn small bold confirm-step-btn"
                >
                  {t('transaction:confirmPickUpDelivery')}
                </GHref>
              </div>
            </div>
            {step > 0 ? (
              <div className="checked-step">
                <FontAwesomeIcon icon={faCheck} fontSize={24} aria-hidden="true" />
              </div>
            ) : null}
          </div>
          <div className="d-flex justify-space pos-rel border-b">
            <div className="w-100">
              <div className="p-10">
                <div className="d-flex">
                  <div className="step-no mr-10">2</div>
                  <div className="flex-1">
                    <p>
                      {t('transaction:confirmSelectedRoute')}
                      <br />
                      {t('transaction:dragBetween')}
                    </p>
                    <p>
                      {t('transaction:selectedDistance')}:
                      {' '}
                      {' '}
                      <strong>
                        <DistanceInKm value={selectedDistance} />
                      </strong>
                    </p>
                    {form?.emptyKm && (
                      <p>
                        {t('transaction:emptyKmDistance')}:
                        {' '}
                        <strong>
                          <DistanceInKm value={form?.emptyKm} />
                        </strong>
                      </p>
                    )}
                  </div>
                </div>
                <div className="ml-40">
                  <div>
                    <GHref
                      onClick={() => setstep(2)}
                      disabled={step < 1 || !selectedDistance}
                      className="btn standard-btn small  bold confirm-step-btn-2"
                    >
                      {t('transaction:confirmRoute')}
                    </GHref>
                  </div>
                </div>
              </div>
            </div>
            {step > 1 && (
              <div className="checked-step">
                <FontAwesomeIcon icon={faCheck} fontSize={24} aria-hidden="true" />
              </div>
            )}
          </div>
          <div className="d-flex justify-space pos-rel border-b">
            <div>
              <div className="p-10">
                <div className="d-flex align-center">
                  <div className="step-no mr-10">3</div>
                  <div className="flex-1">{t('transaction:enterBid')}</div>
                </div>
                <div className="italic ml-40">
                  {
                    truckTransaction?.matchedTruck?.targetPrice
                      ? (
                        <>
                          {t('transaction:preferredPriceIs', { company: truckTransaction?.matchedTruck?.company?.name || t('transaction:theCompany') })}

                          {' '}
                          <GCurrency value={truckTransaction?.matchedTruck?.targetPrice} />
                          {' '}
                          {truckTransaction?.matchedTruck?.priceType}
                          {' '}
                          {t('transaction:paymentTermsAre')}
                          {' '}
                          {truckTransaction?.matchedTruck?.paymentTerm?.days}
                          {' '}
                          {t('transaction:days')}
                        </>
                      )
                      : <>{t('transaction:noPreferredPrice')}</>
                  }
                </div>
                <div className="mt-20">
                  <div className="d-flex">
                    <div className="mr-20">
                      <GInput
                        name="bid"
                        errors={errors}
                        onChange={onChange}
                        form={form}
                        type="currency"
                        currency="€"
                        label={`${t('offer:enterYourOffer')} (${truckTransaction?.matchedTruck?.priceType})`}
                        labelclassName="form-label text-12"
                        className="form-input w-auto"
                        placeholder={`${t('offer:yourPrice')} €`}
                      />
                    </div>
                    {truckTransaction.isNegotiable ? (
                      <>
                        <div className="mr-20">
                          <GInput
                            name="paymentTerm"
                            errors={errors}
                            onChange={onChange}
                            form={form}
                            type="number"
                            labelclassName="form-label text-12"
                            label={`${t('offer:paymentTerms')} (${t('offer:optional')})`}
                            className="form-input w-auto"
                            placeholder={`${t('offer:paymentTerms')} ${t('offer:days')}`}
                          />
                        </div>
                      </>
                    ) : null}
                  </div>
                  <GHref
                    onClick={sendBid}
                    submitting={submitting}
                    disabled={!form.bid || step !== 2 || submitting}
                    className="btn standard-btn   small bold confirm-step-btn-3 mt-16"
                  >
                    {savingRoute
                      ? <>{t('transaction:savingRoute')} ... </>
                      : <Trans i18nKey="offer:sendBid" />}
                  </GHref>
                </div>
              </div>
            </div>
            {step > 2 && (
              <div className="checked-step">
                <FontAwesomeIcon icon={faCheck} fontSize={24} aria-hidden="true" />
              </div>
            )}
          </div>
        </div>
        {step > 2 && <OfferSentMessage type="truck" form={form} />}
      </td>
    </tr>

  )
}

export default TruckOffer
